import React from 'react';
import { Link } from 'react-router-dom';
import '../style/ObituaryCard.css';

export default function ObituaryCard({ deceased, agencyId }) {
    if (!deceased) return null;

    const mainColor = deceased.main_color || '#4169E1';


    // Calculate age
    const calculateAge = (birthDate, deathDate) => {
        if (!birthDate || !birthDate.date || !deathDate || !deathDate.date) return null;
        const birth = new Date(birthDate.date);
        const death = new Date(deathDate.date);
        let age = death.getFullYear() - birth.getFullYear();
        const monthDiff = death.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && death.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    };

    const age = calculateAge(deceased.birth_date, deceased.death_date);

    // Get years for display
    const getBirthYear = () => {
        if (!deceased.birth_date || !deceased.birth_date.date) return '';
        return new Date(deceased.birth_date.date).getFullYear();
    };

    const getDeathYear = () => {
        if (!deceased.death_date || !deceased.death_date.date) return '';
        return new Date(deceased.death_date.date).getFullYear();
    };

    // Get ceremony info from API
    const hasCeremony = deceased.ceremonies && deceased.ceremonies.length > 0;
    const ceremony = hasCeremony ? deceased.ceremonies[0] : null;

    // Format ceremony date
    const getCeremonyDate = () => {
        if (!ceremony || !ceremony.date_time || !ceremony.date_time.date) return '';
        const date = new Date(ceremony.date_time.date);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const ceremonyDate = getCeremonyDate();
    const ceremonyCity = ceremony?.city || '';
    const ceremonyZipcode = ceremony?.zipcode || '';

    // Extract department code from zipcode (first 2 digits)
    const getDepartmentCode = () => {
        if (!ceremonyZipcode) return '';
        return ceremonyZipcode.toString().substring(0, 2);
    };

    return (
        <div className="obituary-card-horizontal">
            <div className="card-main-content">
                <div className="card-info-section">
                    {/* Left - Deceased Info */}
                    <div className="card-info-left">
                        <h3 className="deceased-full-name">
                            {deceased.full_name_long || `${deceased.first_name} ${deceased.last_name}`}
                            {(getBirthYear() || getDeathYear()) && (
                                <span className="deceased-years"> ({getBirthYear()}/{getDeathYear()})</span>
                            )}
                        </h3>

                        <p className="deceased-details">
                            {deceased.civility_short === "Mme" || deceased.civility_short === "Mlle" ? "Elle est née" : "Il est né"} à {deceased.birth_place_city || 'Lieu non précisé'}, il y a {age} ans et résidait à {deceased.city || 'Lieu non précisé'}.
                        </p>
                    </div>

                    {/* Right - Ceremony Info */}
                    {hasCeremony && (
                        <div className="card-info-right">
                            <p className="ceremony-info-text">
                                <strong>Date et lieu de la cérémonie :</strong><br />
                                {ceremonyDate}
                                {ceremonyCity && ` à ${ceremonyCity}`}
                                {getDepartmentCode() && ` (${getDepartmentCode()})`}
                            </p>
                        </div>
                    )}
                </div>
            </div>

            {/* Bottom - Action buttons */}
            <div className="card-actions-bottom">
                <div className="btn-container-left">
                    <Link
                        to={`/avis-deces/${agencyId}/1/${deceased.id}`}
                        state={{ deceased, agencyId }}
                        className="btn-obituary"
                    >
                        Avis de décès
                    </Link>
                </div>
                <div className="btn-container-right">
                    <Link
                        to={`/avis-deces/${agencyId}/1/${deceased.id}#ceremonie`}
                        state={{ deceased, agencyId }}
                        className="btn-ceremony-info"
                    >
                        Informations sur la cérémonie
                    </Link>
                </div>
            </div>

            {/* Footer - Funeral home */}
            <div className="funeral-footer" style={{ backgroundColor: mainColor }}>
                <span className="funeral-info-line">
                    {deceased.agency?.name || 'POMPES FUNÈBRES'} {deceased.agency?.address ? `${deceased.agency.address},` : ''} {deceased.agency?.zipcode} {deceased.agency?.city} - {deceased.agency?.phone}
                </span>
            </div>
        </div>
    );
}
